import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './index.css'
import './lib/i18n'
import { applyTheme, resolveInitialTheme } from './lib/theme'

// Applied before the first render so the initial paint already matches the
// resolved theme — no light-then-dark flash on load.
applyTheme(resolveInitialTheme())

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Root container is missing from index.html.')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
